import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTxInsights } from '../../actions'
import { disableErrorFilter, enableErrorFilter } from '../../actions/error_filter'
import { fetchErrors } from '../../actions/error_management'

const ErrorFilter = (props) => {
  const defaultFilter = 'Error: No Error'

  const handleSelectFilter = (e) => {
    const error = e.target.value === defaultFilter ? null : e.target.value
    props.updateFilter({ error })
  }

  useEffect(() => {
    props.fetchErrors()
  }, [])

  const selectedFilter = props.filter ? props.filter : defaultFilter
  if (!props.errors) {
    return null
  }

  const errors = props.errors.sort((a, b) =>
    a.error_code_name < b.error_code_name ? -1 : a.error_code_name > b.error_code_name ? 1 : 0
  )
  return (
    <div className='form-group'>
      <select value={selectedFilter} name='status' id='status' className='form-control' onChange={handleSelectFilter}>
        <option key={defaultFilter} defaultValue={defaultFilter}>
          {defaultFilter}
        </option>
        {errors.map((error) => (
          <option key={error.error_code_id} value={error.error_code_id}>
            {error.error_code_name}
          </option>
        ))}
      </select>
    </div>
  )
}

const mapStateToProps = (state) => ({
  errors: state.errorManagement.errors,
  searchTerm: state.transactionSearch.searchTerm,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchUsersTxInsights,
      fetchErrors,
      disableErrorFilter,
      enableErrorFilter,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorFilter))
